import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import CharacterPage from "@/pages/character/page";
import CharactersPage from "@/pages/characters/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryName",
    element: <CategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/news/detail/:newsId",
    element: <NewsDetailPage />,
  },
  {
    path: "/news",
    element: <NewsListPage />,
  },
  {
    path: "/character/:id",
    element: <CharacterPage />,
  },
  {
    path: "/characters",
    element: <CharactersPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;